module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone_selected.276faabb.svg";